
const headers = [
    {
      label: 'เลขรายการ',
      field: 'codeList',
      thClass: 'text-center',
    },
    // {
    //   label: 'ประเภท / จังหวัด',
    //   field: 'verifyDep',
    //   thClass: 'text-center',
    // },
    {
      label: 'ชื่อสถานประกอบการ',
      field: 'compName',
      thClass: 'text-center',
    },
    {
      label: 'ประกาศ/คำสั่ง/กฏกระทรวง/ระเบียบ',
      field: 'verifyMinistry',
      thClass: 'text-center',
    },
    {
      label: 'วันที่ออกตรวจ / ผลการตรวจสอบ',
      field: 'verifyDate',   
      thClass: 'text-center',
    },
    {
      label: 'จัดการ',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers